module.exports = __webpack_public_path__ + "static/media/enroute.c5d28fe1.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/enroute.svg
// module id = ./src/assets/icons/enroute.svg
// module chunks = 0